import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useLanding } from '@/components/Landing/LandingKit';
import { EditorialLink } from '@/components/Landing/LandingValueStory';
import { AGENT_INTEGRATIONS, AGENT_INTEGRATION_MORE } from '@/constants/apiContent';
import { ApiBody, ApiSection, ApiSplit, ApiTitle } from './ApiEditorial';

function ApiAgents() {
  const { c, isXS, isCompact } = useLanding();
  return (
    <ApiSection label="Coding agents and integrations">
      <ApiSplit>
        <View style={{ flex: isCompact ? undefined : 0.9, minWidth: 0 }}>
          <ApiTitle>Use your existing tools.</ApiTitle>
          <ApiBody style={{ marginTop: 20 }}>Connect your editor or coding agent with a Gab AI key. The API supports OpenAI and Anthropic request formats, streaming, and tool calls.</ApiBody>
          <ApiBody style={{ fontSize: 14, lineHeight: 23, marginTop: 16 }}>Each setup guide covers the client’s base URL, model settings, and compatibility details.</ApiBody>
        </View>
        <View style={{ flex: isCompact ? undefined : 1.5, minWidth: 0 }}>
          {AGENT_INTEGRATIONS.map(item => (
            <View key={item.name} style={{ flexDirection: isXS ? 'column' : 'row', alignItems: isXS ? 'flex-start' : 'center', justifyContent: 'space-between', paddingVertical: 12, borderBottomWidth: 1, borderBottomColor: c.rule }}>
              <EditorialLink href={item.href}><Text weight="medium" style={{ color: c.ink, fontSize: 18 }}>{item.name}</Text></EditorialLink>
              <Text style={{ color: c.muted, fontSize: 13, lineHeight: 21, paddingBottom: isXS ? 8 : 0 }}>{item.protocol}</Text>
            </View>
          ))}
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', columnGap: 24, marginTop: 16 }}>
            {AGENT_INTEGRATION_MORE.map(item => <EditorialLink key={item.name} href={item.href}>{item.name}</EditorialLink>)}
          </View>
        </View>
      </ApiSplit>
    </ApiSection>
  );
}
export default React.memo(ApiAgents);
